var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"recent"},_vm._l((_vm.recentPosts),function(item,i){return _c('li',{key:i},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }